import React, { Component } from 'react';
import faqs from '../../../data/faqs.json';
import { Accordion, Card, Button } from 'react-bootstrap';

class Faqs extends Component {
    render() {
        return (
            <section className="section-padding our-faqs">
                <div className="container">
                    <div className="section-header">
                        <div className="section-heading text-center">
                            <h3 className="text-custom-black fw-600">Frequently Ask Questions</h3>
                            <div className="section-description">
                                <p className="text-theme fs-16 fw-500">
                                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text.</p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-7">
                            <Accordion defaultActiveKey={1} className="custom-accordion d-block mb-md-80">
                                {faqs.map((item, i) => (
                                    <Card key={i}>
                                        <Accordion.Collapse eventKey={1 + i} className="collapseparent">
                                            <Card.Body>
                                                <div dangerouslySetInnerHTML={{ __html: item.text }} />
                                            </Card.Body>
                                        </Accordion.Collapse>
                                        <Card.Header>
                                            <Accordion.Toggle as={Button} variant="link" eventKey={1 + i}>
                                                {item.title}
                                            </Accordion.Toggle>
                                        </Card.Header>
                                    </Card>
                                ))}
                            </Accordion>
                        </div>
                        <div className="col-lg-5 align-self-center">
                            <div className="faq-right text-center">
                                <div className="img-wrap mb-xl-20">
                                    <img src={process.env.PUBLIC_URL + "/assets/images/aside.jpg"} className="image-fit" alt="img" />
                                </div>
                                <h3 className="text-custom-black">Any Question ?</h3>
                                <p className="text-light-white mb-xl-20">You can ask anything you want to know about Feedback?.</p>
                                <div className="form mb-xl-20">
                                    <input type="search" name="#" className="form-control form-control-custom" placeholder="Enter Here" />
                                </div>
                                <button type="submit" className="btn-submit btn_text_effect"><span className="button_title">Send</span></button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default Faqs;